/** Datos de negocio guardados (empresa materializada o borrador pendiente de pago). */
export function userHasSignupBusinessData(user) {
  if (!user) return false;
  const pending = user.subscription?.pendingCompany;
  if (pending && typeof pending === 'object') {
    return Boolean(String(pending.name || '').trim());
  }
  if (user.subscription?.companyId) return true;
  return Boolean(
    String(user.company || '').trim()
    || String(user.address || '').trim()
  );
}
